import { PlacementWithLogical, Tag, useDisclosure } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../common/hooks/useBrandedTranslation"
import CustomTooltip from "./CustomTooltip"

type Props = {
  tooltipLabel?: string
  tooltipPlacement?: PlacementWithLogical
  size?: "xs" | "md"
}

/* Don't pass a tooltipLabel value to hide the tooltip */
const NewIndicator = ({ tooltipLabel = "", tooltipPlacement = "top-start", size = "md" }: Props) => {
  const { t } = useBrandedTranslation()
  /* This makes a controlled tooltip so it shows on touch on mobile */
  const { isOpen, onOpen, onToggle, onClose } = useDisclosure()
  return (
    <CustomTooltip label={tooltipLabel} placement={tooltipPlacement} gutter={12} isOpen={isOpen}>
      <Tag
        variant="indicatorNew"
        mr="2"
        size={size}
        cursor="default"
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onToggle()
        }}
      >
        {t("indicator-new")}
      </Tag>
    </CustomTooltip>
  )
}

export default NewIndicator
